import { ActionBanner } from "../components/Dashboard";
import XFlowVbanCard from "../components/Dashboard/XFlowVbanCard";
import { AddIcon } from "../components/Icons";
import { useWalletFundContext } from "../context/WalletFundContext";
import Chart1 from "../assets/img/chart1.png";

import { XFlowPartnerContextProvider } from "../context/XFlowPartners";
import { XFlowReceivablesContextProvider } from "../context/XFlowReceivables";
import { NavLink, Outlet } from "react-router-dom";

const steps = [
  { id: 1, name: "Initiate", to: "/simple-payment" },
  {
    id: 2,
    name: "Receivable",
    to: "/simple-payment/receivable",
    // validationSchema: receivableFormSchema,
  },
  {
    id: 3,
    name: "Summary",
    to: "/simple-payment/partner",
  },
];

export default function XFlowPaymentLayout() {
  const { walletData: walletDataArr } = useWalletFundContext();

  const walletData = walletDataArr?.find((el) => el.curSymbol === "USD");

  return (
    <main>
      <ActionBanner />
      <div
        className="grid grid-cols-[2fr,2fr,1fr] gap-6 mb-6"
        id="total-amount-card"
      >
        <div className="card h-[139px] flex flex-col justify-between">
          <h2 className="font-semibold text-lg mt-2">Total Amount</h2>

          <div className="flex justify-between items-center">
            <div>
              <p>
                <span className="font-bold text-3xl">
                  {walletData?.balance}
                </span>{" "}
                <span className="font-medium text-xs text-[#9C9FAD]">
                  / This Month
                </span>
              </p>
              <small className="text-[#9C9FAD]">1050.00.last month</small>
            </div>

            <div>
              <img src={Chart1} alt="chart" />
            </div>
          </div>
        </div>

        <XFlowVbanCard />

        <div className="w-[255px] card flex flex-col justify-center gap-2">
          <button className="flex items-center gap-2 font-semibold text-[#6F6D6D]">
            <AddIcon className="size-9" />
            <span>Add New Currency</span>
          </button>
          <p className="text-sm text-[#9C9FAD]">
            Add a new currency to your account
          </p>
        </div>
      </div>

      <div className="bg-white grid grid-cols-[150px_1fr] gap-5 rounded-md p-8 border border-[#f3f3f5]">
        <nav className="w-[150px] p-1 flex flex-col gap-[1px] border-r border-[#EAECF0]">
          {steps.map((el) => (
            <div key={el.id}>
              <NavLink
                type="button"
                className={({ isActive }) =>
                  `w-full block py-2 transition-colors duration-700 ${
                    isActive ? "text-custom-blue-medium" : "text-[#475467]"
                  } ${el.name === "Summary" ? "cursor-not-allowed" : ""}`
                }
                onClick={(e) => {
                  if (el.name === "Summary") {
                    e.preventDefault();
                  }
                }}
                // disabled={el.id > currentStep && isStepValid(el.id)}
                to={el.to}
                end
              >
                {({ isActive }) => (
                  <p className="flex items-center gap-1">
                    <span
                      className={`w-8 h-8 text-xs font-semibold rounded-full inline-flex items-center justify-center border-2 ${
                        isActive
                          ? "text-custom-blue-medium border-custom-blue-medium"
                          : "border-[#D0D5DD]"
                      }`}
                    >
                      0{el.id}
                    </span>{" "}
                    {el.name}
                  </p>
                )}
              </NavLink>
              {el.id !== steps.length && (
                <div className="w-[1px] h-12 bg-[#D0D5DD] ml-4" />
              )}
            </div>
          ))}
        </nav>

        <XFlowPartnerContextProvider>
          <XFlowReceivablesContextProvider>
            <Outlet />
          </XFlowReceivablesContextProvider>
        </XFlowPartnerContextProvider>
      </div>
    </main>
  );
}
